import {LabelRegular, Loading, TextRegular, TextSemiBold} from '@hm/fundamental'

import {useRiskSurveyTranslation} from '../../hooks'

type SubmittingStepProps = {
  importResultStatus?: 'success' | 'error' | null
  importResultMessage?: string | null
}

export const SubmittingStep = ({importResultStatus, importResultMessage}: SubmittingStepProps) => {
  const {t} = useRiskSurveyTranslation()

  return (
    <div className="flex flex-col gap-4 items-center py-6">
      {!importResultStatus ? (
        <>
          <Loading variant="primary" size="small" />
          <TextRegular>{t('import.inProgress')}</TextRegular>
        </>
      ) : (
        <>
          <TextSemiBold>
            <span className={importResultStatus === 'success' ? 'text-positive' : 'text-negative'}>
              {importResultStatus === 'success' ? t('import.success') : t('import.failed')}
            </span>
          </TextSemiBold>
          {importResultMessage && (
            <LabelRegular className="text-foreground_faded text-center">
              {importResultMessage}
            </LabelRegular>
          )}
        </>
      )}
    </div>
  )
}
